<template>
  <section>
    <div class="row col-md-12">
      <div class="form-group">
        <div :class="searchClass">
          <div class="input-group input-group-lg">
      <span class="input-group-addon" id="basic-addon1">
        <span class="glyphicons"
              :class="[loading ? 'glyphicons-refresh glyphicons-refresh-animate' : 'glyphicons-search']"></span>
      </span>
            <input type="text"
                   class="form-control"
                   placeholder="Lookup a Person"
                   autocomplete="off"
                   v-model="query"
                   @input="search"/>
          </div>
        </div>
        <div class="col-sm-2"><a href="javascript:void(0)" v-if="showingResults" @click="clearResults()">Clear
          Results</a></div>
      </div>
      <div class="form-group">
        <div :class="resultClass">
          <transition name="fade" mode="out-in">
            <table class="table table-condensed table-striped" v-if="personResults && personResults.length > 0">
              <thead>
              <tr>
                <th width="10%" v-if="showSelect || showAdminEdit"></th>
                <th>Name</th>
                <th>
                  <div class="row">
                    <div class="col-sm-6">Current Institution(s)</div>
                    <div class="col-sm-6">Current Title(s)</div>
                  </div>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="person in personResults">
                <td v-if="showSelect">
                  <button type="button" class="btn btn-xs btn-default" @click="selectPerson(person)">Select</button>
                </td>
                <td v-if="showAdminEdit">
                  <button type="button" class="btn btn-xs btn-default" @click="selectPerson(person)">Edit</button>
                </td>
                <td>{{ person.firstName }} {{ person.middleInitial != null ? person.middleInitial : '' }}
                  {{ person.lastName }}
                  <span v-if="showAdminEdit && person.personId" class="text-muted small">({{ person.personId }})</span>
                </td>
                <!--<td></td>-->
                <td>
                  <template v-for="memberPersonOrg in person.memberPersonOrgs"><div class="row"
                       v-if="!memberPersonOrg.deleteFlag || memberPersonOrg.deleteFlag === 'N'">
                    <div class="col-sm-6" v-if="showSelect">{{ memberPersonOrg.memberOrg != null ? memberPersonOrg.memberOrg.nameOfficial : '' }}</div>
                    <div class="col-sm-6" v-if="showContactCard">
                      <a href="javascript:void(0)" @click="contactCard(person.personId, memberPersonOrg.orgId)">
                        {{ memberPersonOrg.memberOrg != null ? memberPersonOrg.memberOrg.nameOfficial : '' }}</a></div>
                    <div class="col-sm-6">
                      <template v-for="orgTitle in memberPersonOrg.memberPersonOrgTitles"><p
                         v-if="(!orgTitle.deleteFlag || orgTitle.deleteFlag === 'N')
                   && orgTitle.titleCode !== 'HC'">{{ orgTitle.memberTitle.description }}</p></template>
                      <template v-for="coachSport in memberPersonOrg.memberCoachSportDates"><p
                         v-if="!coachSport.deleteFlag || coachSport.deleteFlag === 'N'">Head Coach -
                        {{ coachSport.memberSport.description }}</p></template>
                    </div>
                  </div></template>
                </td>
                <td><a href="javascript:void(0)" v-if="hasHistory(person)" @click="showHistory(person)">Inst.
                  History</a></td>
              </tr>
              </tbody>
            </table>
            <p class="text-center" v-else-if="showingResults"><em>No results found.</em></p>
          </transition>
        </div>
      </div>
    </div>

    <div class="modal fade" id="history-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{ personHistory.firstName }} {{ personHistory.lastName }} Institution History</h4>
          </div>
          <div class="modal-body">
            <p><em>Note: Institution history is not listed in chronological order.</em></p>
            <table class="table table-condensed table-striped">
              <thead>
              <tr>
                <th class="col-sm-6">Institution</th>
                <th class="col-sm-6">Title(s)</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="memberPersonOrg in personHistory.memberPersonOrgs"><tr  v-if="memberPersonOrg.deleteFlag === 'Y'">
                <td class="col-sm-6">{{ memberPersonOrg.memberOrg != null ? memberPersonOrg.memberOrg.nameOfficial : ''}}</td>
                <td class="col-sm-6">
                  <template v-for="orgTitle in memberPersonOrg.memberPersonOrgTitles"><p
                     v-if="orgTitle.titleCode !== 'HC'">{{ orgTitle.memberTitle.description }}</p></template>
                  <p v-for="coachSport in memberPersonOrg.memberCoachSportDates">Head Coach -
                    {{ coachSport.memberSport.description }}</p>
                </td>
              </tr></template>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </section>
</template>

<script>
import PersonService from '../endpoints/PersonService'
import {debounce} from 'lodash'
import axios from 'axios'
import $ from 'jquery'
import Notifier from '../common/Notifier'
import { markRaw } from 'vue'

export default {
  emits: ['select-person', 'show-contact', 'show-results'],
  props: {
    showSelect: {
      type: Boolean,
      default: true
    },
    showContactCard: {
      type: Boolean,
      default: false
    },
    showAdminEdit: {
      type: Boolean,
      default: false
    },
    searchClass: {
      type: String,
      default: 'col-sm-8 col-sm-offset-2'
    },
    resultClass: {
      type: String,
      default: 'col-sm-10 col-sm-offset-1'
    }
  },
  data () {
    return {
      query: '',
      personResults: [],
      minChars: 3,
      error: '',
      loading: false,
      showingResults: false,
      cancelSource: null,
      personHistory: {}
    }
  },
  created () {
    this.searchDebounced = debounce(this.performSearch, 500)
  },
  beforeUnmount () {
    this.cancelSearch()
  },
  methods: {
    search () {
      this.searchDebounced()
    },
    cancelSearch () {
      this.searchDebounced.cancel()
      if (this.cancelSource) {
        this.cancelSource.cancel()
      }
      this.cancelSource = null
      this.loading = false
    },
    performSearch () {
      this.cancelSearch()
      if (!this.query || (this.minChars && this.query.length < this.minChars)) {
        this.showingResults = false
        this.personResults = []
        return
      }

      const source = markRaw(axios.CancelToken.source())
      const query = this.query
      this.cancelSource = source
      this.error = ''
      this.loading = true

      PersonService.searchPerson(query, source)
        .then(response => {
          if (this.cancelSource !== source || this.query !== query) return
          this.personResults = response.data
          this.showingResults = true
        })
        .catch(error => {
          if (axios.isCancel(error) || this.cancelSource !== source) return
          this.error = error.message
          Notifier.error(error.message)
        })
        .finally(() => {
          if (this.cancelSource === source) {
            this.cancelSource = null
            this.loading = false
          }
        })
    },
    clearResults: function () {
      this.cancelSearch()
      this.personResults = []
      this.query = ''
      this.showingResults = false
    },
    selectPerson: function (person) {
      this.$emit('select-person', person)
    },
    contactCard: function (personId, orgId) {
      let params = {
        personId: personId,
        orgId: orgId
      }
      this.$emit('show-contact', params)
    },
    showHistory: function (person) {
      this.personHistory = person
      $('#history-modal').modal('show')
    },
    hasHistory: function (person) {
      for (let i = 0; i < person.memberPersonOrgs.length; i++) {
        if (person.memberPersonOrgs[i].deleteFlag && person.memberPersonOrgs[i].deleteFlag === 'Y') {
          return true
        }
      }

      return false
    }
  },
  watch: {
    showingResults: function (val) {
      this.$emit('show-results', val)
    }
  }
}
</script>

<style>
.glyphicons-refresh-animate {
  -animation: spin .7s infinite linear;
  -webkit-animation: spin2 .7s infinite linear;
}

@-webkit-keyframes spin2 {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: scale(1) rotate(0deg);
  }
  to {
    transform: scale(1) rotate(360deg);
  }
}
</style>
